import { Flex } from "@chakra-ui/react"
import CopyLink from "./CopyLink"
import NativeLink from "./NativeLink"
import QRCodeLink from "./QRCodeLink"

const ShareLink = ({ url }) => {
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      data-testid={`share-link-url-${url}`}
      gap={8}
    >
      <CopyLink url={url} />
      <NativeLink url={url} />
      <QRCodeLink url={url} />
    </Flex>
  )
}

export default ShareLink
